module.exports = __webpack_public_path__ + "static/media/ic_popup_kyc_underprocess.2620f94c.svg";